import React, { FC } from "react";
import ContentLoader from "react-content-loader";

const ProfessionalProfileLoader: FC = props => (
	<ContentLoader
		style={{ minHeight: "205px" }}
		speed={2}
		width={375}
		height={"100%"}
		viewBox="0 0 375 210"
		backgroundColor="#f3f3f3"
		foregroundColor="#ecebeb"
		{...props}
	>
		<circle cx="83" cy="83" r="55" />
		<rect x="145" y="30" rx="7" ry="7" width="209" height="28" />
		<rect x="145" y="62" rx="7" ry="7" width="141" height="23" />
		<rect x="145" y="92" rx="7" ry="7" width="154" height="14" />
		<rect x="145" y="117" rx="7" ry="7" width="203" height="20" />
		<rect x="32" y="155" rx="7" ry="7" width="285" height="30" />
	</ContentLoader>
);

export default ProfessionalProfileLoader;
